import React, {useState} from "react";
import {IoLogoWhatsapp} from "react-icons/io5";
import {Button, TextField} from "@mui/material";
import {LoginCalculadoraMacros} from "../components/calculadoraMacros/loginCalculadora.jsx";
import {Macros} from "../components/calculadoraMacros/macros.jsx";

const CalculadorMacros = () => {

    const [loginSuccesfull, setLoginSuccessful] = useState(false)
    return(
        <div className={'bg-whiteBG   px-5 flex items-center flex-col justify-center'}>
            {loginSuccesfull ? <Macros/> : <LoginCalculadoraMacros setLoginSuccessfull={setLoginSuccessful}/>}
        </div>
    )
}

export default CalculadorMacros;
